import { render, staticRenderFns } from "./teip-table.vue?vue&type=template&id=69451005&scoped=true&"
import script from "./teip-table.vue?vue&type=script&lang=ts&"
export * from "./teip-table.vue?vue&type=script&lang=ts&"
import style0 from "./teip-table.vue?vue&type=style&index=0&id=69451005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69451005",
  null
  
)

export default component.exports